module.exports = __webpack_public_path__ + "static/media/education-object-3-2-2.ac0a1e49.svg";